export function unflattenArray(items: Array<any>, id: any): Array<any> {
    return items
        .filter((item) => (!item.parent.data && !id) || item?.parent?.data?.id === id)
        .map((item) => ({ ...item, children: unflattenArray(items, item.id) }))
        .sort((a, b) => (a.index > b.index ? 1 : -1))
}

// Constraints
export function constraints(obj: Record<string, any> | null, key: string, constraint: string) {
    if (!obj) return false
    if (!obj?.constraints) return true
    let res = true
    if (key in obj.constraints && constraint in obj.constraints[key]) {
        res = obj.constraints[key][constraint]
    }
    return res
}

export function isWritable(obj: Record<string, any> | null, key: string) {
    return constraints(obj, key, 'writable')
}

export function isAuthorized(obj: Record<string, any> | null, key: string) {
    return constraints(obj, key, 'authorized')
}

export function isRelevant(obj: Record<string, any> | null, key: string) {
    return constraints(obj, key, 'relevant')
}
